import { iAvatarXInformacoes } from '../../../../../interfaces'
import { parseJwt } from '../../../../../services/token'

export interface iFeedbackPermissoes {
  criador: iAvatarXInformacoes
  convidado: iAvatarXInformacoes
  respondente: number
  possuiRespostas: boolean
  podeVisualizarRespostas: boolean
}

export type tBotaoFeedback = 'responder' | 'visualizar resposta' | 'alternar visualizacao'

// O admin que é o próprio participante do feedback é tratado como participante
export function IsAdmNaoParticipante(participanteId: string): boolean {
  const { cid, adm } = parseJwt()
  return adm === 'True' && participanteId !== cid
}

export function VerificarBotaoFeedback(nome: tBotaoFeedback, feedback?: iFeedbackPermissoes | null): boolean {
  if (feedback === undefined || feedback === null) return false
  const { cid } = parseJwt()
  const isCriador = feedback.criador.id === cid
  const isParticipante = feedback.convidado.id === cid

  if (nome === 'responder') {
    return (isCriador && (feedback.respondente === 0 || feedback.respondente === 2) && !(feedback.criador.info2?.includes('Respondido') ?? false)) ||
      (isParticipante && (feedback.respondente === 1 || feedback.respondente === 2) && !(feedback.convidado.info2?.includes('Respondido') ?? false))
  } else if (nome === 'visualizar resposta') {
    return feedback.podeVisualizarRespostas
  } else if (nome === 'alternar visualizacao') {
    return (isCriador || IsAdmNaoParticipante(feedback.convidado.id)) && feedback.possuiRespostas
  }
  return false
}
